(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecomm-faqs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.question').forEach((question) => {
    question.addEventListener('click', function () {
      const faq = this.closest('.faq');
      const answer = faq.querySelector('.answer');
      const plusIcon = faq.querySelector('.icon.plus');
      const minusIcon = faq.querySelector('.icon.minus');

      answer.classList.toggle('hidden');
      plusIcon.classList.toggle('hidden');
      minusIcon.classList.toggle('hidden');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
